import { z } from 'zod';

/** Feedback categories the storefront form offers. */
export const FEEDBACK_CATEGORIES = ['suggestion', 'complaint', 'praise', 'bug', 'other'] as const;
export const FEEDBACK_STATUSES = ['new', 'read', 'archived'] as const;

/** Public feedback submission (works logged-out; name/email optional). */
export const createFeedbackSchema = z.object({
  category: z.enum(FEEDBACK_CATEGORIES).default('other'),
  message: z.string().min(1).max(5000),
  name: z.string().max(200).optional(),
  email: z.string().email().max(300).optional().or(z.literal('')),
  subject: z.string().max(200).optional(),
  rating: z.number().int().min(1).max(5).optional(),
  pageUrl: z.string().max(2048).optional(),
});
export type CreateFeedbackInput = z.infer<typeof createFeedbackSchema>;

/** Admin inbox triage — flip a feedback row's status. */
export const updateFeedbackStatusSchema = z.object({
  status: z.enum(FEEDBACK_STATUSES),
});
